import emptyIcon from '../../assets/img/empty.png';
import getFormatMessage from '../../locales/get-format-message';

export const ChartEmpty = () => {
  return (
    <div style={{ padding: '36px 0' }}>
      <img src={emptyIcon} style={{ display: 'block', margin: '0 auto' }} />
      <div
        style={{
          textAlign: 'center',
          fontSize: 14,
          color: '#86909C',
          lineHeight: '22px',
        }}
      >
        {getFormatMessage('no_data_available')}
      </div>
    </div>
  );
};
